import { useEffect, useState } from "react";
import { Button, Col, Container, Form, InputGroup, Row, Table } from "react-bootstrap"
import { Helmet } from "react-helmet"
import { useFieldArray, useForm, useWatch } from "react-hook-form";

const DocTypeName = ({ index, docName }) => {
    const getDocumentName = (index) => {
        const documentNames = {
            1: "Паспорт гражданина РФ",
            2: "Загранпаспорт",
            3: "Военный билет",
            4: docName
        };

        return documentNames[index] || "";
    };
    return getDocumentName(index);
}

const PreFormRefund = ({ data }) => {
    return (
        <>
            <div className="border border-2 p-3">
                <Row className="justify-content-end border-bottom border-2">
                    <Col lg={6}>
                        <div className="text-end">
                            <p className="mb-1">
                                В Общество с ограниченной ответственностью «Деметра»
                                <br />
                                (Шоу-пространство «Ленинград Центр»)
                            </p>
                            <p className="mb-1"> От <b>{data.lastname} {data.firstname} {data.patronymic}</b></p>
                            <p className="mb-1"><b><DocTypeName index={data.selDocName} docName={data.docName} /></b>, Выдан: <b>{data.issuingAuthority}</b></p>
                            <p className="mb-1">Адрес: <b>{data.address}</b></p>
                            <p className="mb-1">Электронная почта: <b>{data.email}</b></p>
                            <p className="mb-1">Телефон: <b>{data.phone}</b></p>
                        </div>
                    </Col>

                </Row>
                <h4 className="text-center">Заявление</h4>
                <Row className="">
                    <Col>
                        <p>
                            Прошу произвести возврат денежных средств за <b>билеты в количетсве {data.ticket.length}</b> в связи с отказом от посещения
                            зрелищного мероприятия по собственной инициативе/по причине отмены мероприятия.
                        </p>
                    </Col>
                </Row>
                <Table responsive border={1}>
                    <tbody>
                        <tr>
                            <td>Наименование зрелищного мероприятия</td>
                            <td className="w-50">{data.showName}</td>
                        </tr>
                        <tr>
                            <td>
                                Дата, время и место проведения зрелищного
                                мероприятия
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>
                                Место размещения посетителя (ряд, место)
                            </td>
                            <td>{data.ticket.map(seat => <span>ряд: {seat.row} место: {seat.seat},</span>)}</td>
                        </tr>
                        <tr>
                            <td>
                                Стоимость билета
                                <br />
                                (сумма)
                            </td>
                            <td>{data.amount}</td>
                        </tr>
                        <tr>
                            <td>Форме оплаты покупки билета</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Банковские реквизиты</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Номер заказа на сайте</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Цифры банковской карты</td>
                            <td></td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </>
    )
}

export const RefundApplication = ({ t }) => {
    const { register, handleSubmit, formState: { errors }, control, setError, clearErrors } = useForm();
    const { fields, append, remove } = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormProvider)
        name: "ticket", // unique name for your Field Array
    });
    const [ticketRulesChecked, setTicketRulesChecked] = useState(false)
    const [showPreForm, setShowPreForm] = useState(false)
    const [preFormData, setPreFormData] = useState()

    const submit = (data) => {
        if (fields.length === 0) {
            setError("ticket", { message: "Добавьте места в заявление" })
            return
        }
        console.log(data)
        setPreFormData(data)
        setShowPreForm(true)
        // console.log(data)
    }

    useEffect(() => {
        if (fields.length > 0) {
            clearErrors("ticket")
        }
    }, [fields])

    const selectDocName = useWatch({
        control,
        defaultValue: "",
        name: 'selDocName', // имя поля, за которым вы хотите наблюдать
    });
    const typeTicekts = useWatch({
        control,
        defaultValue: "",
        name: 'typeTicekts'
    });
    // useEffect(() => { console.log(typeTicekts) }, [typeTicekts])

    return (
        <>
            <Helmet>
                <title>{t("mainTag.title")}</title>
                <meta name="description" content='Первое в России шоу-пространство "Ленинград Центр"'></meta>
                <meta name="og:title" content={`${t("mainTag.title")}`} />
                <meta name="og:description" content='Первое в России шоу-пространство "Ленинград Центр"' />
                <meta name="keywords" content="шоу- пространство, шоу пространство, ленинград центр, центр ленинград, мюзикл, шоу, представление, афиша" c />
                {/* <meta property="og:image" content={data.headLayoutImageType ? `/api/shows/head-wide-img/${data.id})` : "/Show/091A8332.jpg"} /> */}
            </Helmet>
            <div className="about-haed-layout mb-3">
                <div className="about-head-layout-img" style={{ backgroundImage: `url("/AboutProjcet/about-project.jpg")` }}>
                </div>
                <div className="about-head-mask">
                    <div className="justify-content-end ms-auto me-auto justify-content-end rounded-3"
                        style={{ width: "70%", backgroundColor: "#00000006", padding: "1rem" }}>
                    </div>
                </div>
            </div>
            <Container fluid>

                <Row className="justify-content-center">
                    {!showPreForm ?
                        <Col lg={8}>
                            <div className="text-center">
                                <h3>
                                    ЗАЯВЛЕНИЕ
                                    О ВОЗВРАТЕ БИЛЕТА(-ОВ) (ЭЛЕКТРОННОГО(-ЫХ) БИЛЕТА(-ОВ)
                                </h3>
                                <p>(согласно приказу Министерства культуры РФ от 22 марта 2021 г. № 351)</p>
                            </div>
                            <Form className="justify-content-center" onSubmit={handleSubmit(submit)}>
                                <div className="d-md-flex gap-1 justify-content-center mb-2">
                                    <Form.Group className="flex-fill mb-1">
                                        <>
                                            <Form.Label htmlFor="lastname">{t("form.lastName")}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="lastname"
                                                placeholder={t("form.lastName")}
                                                {...register("lastname", { required: { value: true, message: "Заполните пожалуйсто поле" } })}
                                                isInvalid={errors.lastname}
                                            // isValid
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.lastname?.message}
                                            </Form.Control.Feedback>
                                        </>
                                    </Form.Group>
                                    <Form.Group className="flex-fill mb-1">
                                        <>
                                            <Form.Label htmlFor="firstName">{t("form.firstName")}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="firstName"
                                                placeholder={t("form.firstName")}
                                                {...register("firstname", { required: { value: true, message: "Заполните пожалуйсто поле" } })}
                                                isInvalid={errors.firstname}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.firstname?.message}
                                            </Form.Control.Feedback>
                                        </>
                                    </Form.Group>
                                    <Form.Group className="flex-fill mb-1">
                                        <>
                                            <Form.Label htmlFor="patronymic">{t("form.patronymic")}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="patronymic"
                                                placeholder={t("form.patronymic")}
                                                {...register("patronymic")}
                                            />
                                        </>
                                    </Form.Group>
                                </div>
                                <div className="d-md-flex gap-1 justify-content-center mb-2">
                                    <Form.Group className="flex-fill mb-1">
                                        <>
                                            <Form.Label htmlFor="phone">{t("form.phone")}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="phone"
                                                placeholder={t("form.phone")}
                                                {...register("phone", { required: { value: true, message: "Заполните пожалуйсто поле" } })}
                                                isInvalid={errors.phone}
                                            // isValid
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.phone?.message}
                                            </Form.Control.Feedback>
                                        </>
                                    </Form.Group>
                                    <Form.Group className="flex-fill mb-1">
                                        <>
                                            <Form.Label htmlFor="email">{t("form.firstName")}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="email"
                                                placeholder={'E-Mail'}
                                                {...register("email", { required: { value: true, message: "Заполните пожалуйсто поле" } })}
                                                isInvalid={errors.email}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email?.message}
                                            </Form.Control.Feedback>
                                        </>
                                    </Form.Group>
                                </div>
                                <div className="d-md-flex gap-1 justify-content-center mb-2">
                                    <Form.Group className="gap-1 flex-fill">
                                        <Form.Label>Адрес</Form.Label>
                                        <Form.Control placeholder={"Адрес"}
                                            {...register("address", { required: { value: true, message: "" } })}
                                            isInvalid={errors.issuingAuthority}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Укажите адрес
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <Form.Group className="border-top pt-3">
                                    <Form.Label>Документ удостоверяющий личность</Form.Label>
                                    <div className="mb-1 flex-fill">
                                        <InputGroup>
                                            <InputGroup.Text>
                                                Документ
                                            </InputGroup.Text>
                                            <Form.Select
                                                // defaultValue={""}
                                                isInvalid={errors.selDocName}
                                                {...register("selDocName",
                                                    {
                                                        // onChange: (e) => { setSelDocName(e.target.value) },
                                                        required: { value: true }
                                                    })}>
                                                isValid
                                                <option value={""} hidden disable> --- Выберете наименование документа ---</option>
                                                <option value={1}>Паспорт гражданина РФ</option>
                                                <option value={2}>Загранпаспорт</option>
                                                <option value={3}>Военный билет</option>
                                                <option value={4}>Иной документ</option>
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                Выберите наименование документа
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </div>
                                    {selectDocName == 4 &&
                                        <Form.Group className="gap-1 justify-content-center">
                                            <Form.Label>{t("form.docName")}</Form.Label>
                                            <Form.Control placeholder={t("form.docName")}
                                                className="mb-1 flex-fill"
                                                {...register("docName", { required: { value: true, message: "" } })}
                                                isInvalid={errors.docName}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Укажите наименование документа
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    }
                                    <div className="d-md-flex gap-1 justify-content-center mb-2">
                                        <Form.Group className="flex-fill mb-1">
                                            <>
                                                <Form.Label htmlFor="seriesDoc">Серия</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    id="seriesDoc"
                                                    placeholder={"Серия"}
                                                    {...register("seriesDoc", { required: { value: true, message: "" } })}
                                                    isInvalid={errors.seriesDoc}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Укажите серию документа
                                                </Form.Control.Feedback>
                                            </>
                                        </Form.Group>
                                        <Form.Group className="flex-fill mb-1">
                                            <>
                                                <Form.Label htmlFor="numberDoc">Номер</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    id="numberDoc"
                                                    placeholder={"Номер"}
                                                    {...register("numberDoc", { required: { value: true, message: "" } })}
                                                    isInvalid={errors.numberDoc}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Укажите номер документа
                                                </Form.Control.Feedback>
                                            </>
                                        </Form.Group>
                                        <Form.Group className="flex-fill mb-1">
                                            <>
                                                <Form.Label htmlFor="seriesDoc">Дата выдачи</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    {...register("issuedDoc", { required: { value: true, message: "" } })}
                                                    id="issuedDoc"
                                                    placeholder={"Дата выдачи"}
                                                    isInvalid={errors.issuedDoc}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Укажите дату выдачи документа
                                                </Form.Control.Feedback>
                                            </>
                                        </Form.Group>
                                    </div>
                                    <div className="d-md-flex gap-1 justify-content-center mb-2">
                                        <Form.Group className="gap-1 flex-fill">
                                            <Form.Label>Кем выдан</Form.Label>
                                            <Form.Control placeholder={"Кем выдан"}
                                                {...register("issuingAuthority", { required: { value: true, message: "" } })}
                                                isInvalid={errors.issuingAuthority}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Укажите кем выдан документ
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </Form.Group>
                                <div className="d-md-flex gap-1 justify-content-center mb-2">
                                    <Form.Group className="gap-1 flex-fill">
                                        <Form.Label>Вид билета(-ов)</Form.Label>
                                        <Form.Select placeholder={"Вид билета(-ов)"}
                                            {...register("typeTicekts",
                                                {
                                                    required: { value: true, message: "Укажите вид билета (-ов)" },
                                                })}
                                            isInvalid={errors.typeTicekts}>
                                            <option value={""} hidden> --- укажите вид билета (-ов) ---</option>
                                            <option value={1}>Бумажные билеты</option>
                                            <option value={2}>Электронные билеты</option>
                                            <option value={3}>Кассовый чек</option>
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            Укажите вид билета (-ов)
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div>
                                    <div className="d-lg-flex gap-1 justify-content-center mb-2">
                                        <Form.Group className="gap-1 flex-fill">
                                            <Form.Label>Наименование мероприятия</Form.Label>
                                            <Form.Control placeholder={"Шоу \"Illusio. Повелитель грез\""}
                                                {...register("showName", { required: { value: true, message: "" } })}
                                                isInvalid={errors.showName}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Укажите наименование мероприятия
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="gap-1 flex-fill">
                                            <Form.Label>Дата начало шоу</Form.Label>
                                            <Form.Control
                                                {...register("showDate", { required: { value: true, message: "" } })}
                                                type="datetime-local"
                                                isInvalid={errors.showDate}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Укажите стоимость билета (-ов) (сумма)
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="gap-1 flex-fill">
                                            <Form.Label>Стоимость билета (-ов) (сумма)  </Form.Label>
                                            <Form.Control placeholder={"10000.00"}
                                                {...register("amount", { required: { value: true, message: "" } })}
                                                type="number" step='0.01'
                                                isInvalid={errors.amount}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Укажите стоимость билета (-ов) (сумма)
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div>
                                    {typeTicekts == 2 &&
                                        <Form.Group className="gap-1 flex-fill">
                                            <Form.Label>Номер заказа</Form.Label>
                                            <Form.Control placeholder={"Номер заказа"}
                                                {...register("orderNum", { required: { value: true, message: "" } })}
                                                type="text"
                                                isInvalid={errors.orderNum}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Укажите номер заказа
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    }
                                </div>
                                <div>
                                    <Form.Label>Место размещения (ряд, место)</Form.Label>
                                    {errors?.ticket?.message &&
                                        <div className="text-danger mb-3">
                                            {errors.ticket.message}
                                        </div>
                                    }
                                    {fields.map((item, index) => (
                                        <div key={item.id} className="d-md-flex gap-1 mb-2">
                                            <Form.Group className="gap-1">
                                                {index == 0 && <Form.Label>Ряд или ложа</Form.Label>}
                                                <Form.Control placeholder={"VIP Ложа 5"}
                                                    {...register(`ticket.${index}.row`, { required: { value: true, message: "" } })}
                                                    type="ticket"
                                                    isInvalid={errors.ticket?.[index]?.row}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Укажите ряд или номер ложи
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group className="gap-1">
                                                {index == 0 && <Form.Label>Место</Form.Label>}
                                                <InputGroup>
                                                    <Form.Control placeholder={10}
                                                        {...register(`ticket.${index}.seat`, { required: { value: true, message: "" } })}
                                                        type="text"
                                                        isInvalid={errors.ticket?.[index]?.seat}

                                                    />
                                                    <Button type="button" onClick={() => remove(index)}>X</Button>
                                                </InputGroup>
                                                <Form.Control.Feedback type="invalid">
                                                    Укажите место
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                    ))}
                                </div>

                                <div className="mb-3">
                                    <Button
                                        type="button"
                                        onClick={() => append({ row: "", seat: "" })}
                                    >
                                        Добавить ряд и место
                                    </Button>
                                </div>
                                <div className="mb-1">
                                    <div className=" form-check form-switch mb-1">
                                        <label className="form-check-label">{t("payscheme.agreeWith")}
                                            <a href='https://leningradcenter.ru/api/redirecturls/privacy-policy' target={"_blank"}>{t("form.agreement")}</a></label>
                                        <input type="checkbox" className="form-check-input check-input-lc"
                                            {...register("policy", {
                                                required:
                                                    { value: true, message: "Необходимо согласие на обработку персональных данных" }
                                            })}
                                        />
                                        <br />
                                        {errors.policy && <span className='text-danger'>{errors.policy?.message}</span>}
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <div className=" form-check form-switch">
                                        <label className="form-check-label">
                                            {t("payscheme.agreeWith")}<a href='https://leningradcenter.ru/api/redirecturls/ticket-purchase-rules' target={"_blank"} >{t("form.ticketRules")}</a>
                                        </label>
                                        <input type="checkbox" className="form-check-input check-input-lc"
                                            defaultChecked={ticketRulesChecked}
                                            {...register("pravilo",
                                                {
                                                    required: { value: true, message: "Необходимо согласие c правилами покупки билетов" },
                                                    onChange: () => { setTicketRulesChecked(!ticketRulesChecked) }
                                                })}
                                        />
                                        <br />
                                        {errors.pravilo && <span className='text-danger'>{errors.pravilo?.message}</span>}
                                    </div>
                                </div>
                                <Button type="submit">Подготовит</Button>
                            </Form>
                        </Col>
                        :
                        <Col lg={8}>
                            {/* <PreFormRefund data={preFormData} /> */}
                        </Col>
                    }
                </Row>
            </Container >
        </>
    )
}